<template>
  <custom-button type="button" @click="$emit('click')">
    <svg enable-background="new 0 0 31.444 31.444" version="1.1" viewBox="0 0 31.444 31.444" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
        <path d="m1.119 16.841c-0.619 0-1.111-0.508-1.111-1.127s0.492-1.111 1.111-1.111h13.475v-13.476c1e-3 -0.619 0.509-1.127 1.128-1.127s1.111 0.508 1.111 1.127v13.476h13.475c0.619 0 1.127 0.492 1.127 1.111s-0.508 1.127-1.127 1.127h-13.475v13.476c0 0.619-0.492 1.127-1.111 1.127s-1.127-0.508-1.127-1.127v-13.476h-13.476z" fill="#1E201D"/>
    </svg>
  </custom-button>
</template>

<script>
import customButton from '../UIComponents/CustomButton.vue';
  export default {
    components: {
      customButton
    }

  }
</script>


<style lang="scss" scoped>
svg {
  width: 25px;
  height: 25px;

  path {
    fill: white;
  }
}
</style>